module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_wayo_studio@3x-85a0fa9356d7a88f5149b1840448c4cc.webp";